import React, { FC, useState } from 'react';

import { MESSAGE_STATUS_TRANSLATION_KEY } from '../../../../constants/message';
import { MessageStatus } from '../../../../generated/graphql';
import translate from '../../../../i18n/translate';
import MuiIcon from '../../../MUI/MuiIcon';
import Popover, { ExternalPopoverProps } from '../../../MUI/Popover';

import ComposeStatusSelection from '../../Common/ComposeStatusSelection';

import * as Styled from './styled';

type Props = {
  dataStatusCurrent: MessageStatus;
  requestStatusChange: (status: MessageStatus) => void;
};

/**
 * Status selection for compose modal
 *
 * @param props                     Props passed to the component
 * @param props.dataStatusCurrent   Currently selected status
 * @param props.requestStatusChange Request that selected status is changed
 *
 * @returns                         Component itself
 */
const ComposeModalStatus: FC<Props> = ({
  dataStatusCurrent,
  requestStatusChange,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  /**
   * Handle status selection
   *
   * @param value Value of the selected radio button
   */
  const onStatusChange = (value: MessageStatus) => {
    requestStatusChange(value);
    setAnchorEl(null);
  };

  const popoverHandlers: ExternalPopoverProps = {
    anchorEl,
    onStateChange: setAnchorEl,
  };

  return (
    <Popover
      externalHandlerProps={popoverHandlers}
      shouldHaveOffset={true}
      trigger={
        <Styled.StyledChip
          icon={<MuiIcon fontSize="small" icon="status" />}
          label={translate(MESSAGE_STATUS_TRANSLATION_KEY[dataStatusCurrent])}
          variant="outlined"
        />
      }
    >
      <ComposeStatusSelection
        currentStatus={dataStatusCurrent}
        onStatusChange={onStatusChange}
      />
    </Popover>
  );
};

export default ComposeModalStatus;
